import {Component, EventEmitter, Inject, makeStateKey, Output, PLATFORM_ID, TransferState} from '@angular/core';
import {isPlatformServer, NgClass, NgForOf, NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {SectionsInterface} from "@interfaces/catalog/sections.interface";
import {Observable, of} from "rxjs";
import {EndpointConstant} from "@interfaces/global/endpoint.constant";
import {RequestMethodsService} from "@services/request/request-methods.service";
import {CityOrAddressSelectionInterface} from "@interfaces/catalog/filtration-default-state.const";
import {CityService} from "@services/city/city.service";
import {CategoryInterface} from "@interfaces/catalog/category.interface";

const SECTIONS_KEY = makeStateKey('sections');

@Component({
  selector: 'app-menu-catalog',
  standalone: true,
  imports: [
    NgForOf,
    TranslateModule,
    NgClass,
    NgIf
  ],
  templateUrl: './menu-catalog.component.html',
  styleUrl: './menu-catalog.component.scss'
})
export class MenuCatalogComponent {
  @Output() navigate = new EventEmitter<string>();
  sections!: Array<SectionsInterface>;
  menuItemsForTablet = [
    {
      text: 'navbar.favorites',
      img:'favorites_icon_for_tablet',
      route: '/favorites'
    },
    {
      text: 'navbar.basket.title',
      img:'cart_icon_for_tablet',
      route: '/basket'
    },
    {
      text: 'navbar.orders',
      img:'orders_icon_for_tablet',
      route: '/orders'
    }
  ];
  selectedProduct = 0;
  cityOrAddress!: CityOrAddressSelectionInterface;

  constructor(
    private requestService: RequestMethodsService,
    @Inject(PLATFORM_ID) private platformId: any,
    private state: TransferState,
    private cityService: CityService
  ) {
    const cityOrAddressObject = this.cityService.getObjectCityOrAddress();
    if (!cityOrAddressObject) {
      return;
    }
    this.cityOrAddress = cityOrAddressObject;
    this.getAllSections();
  }

  getAllSectionsObservable(): Observable<any> {
    if (isPlatformServer(this.platformId)) {
      const sections$ =this.requestService.post(
        `${EndpointConstant.section}/${EndpointConstant.filter}`,
        this.cityOrAddress
      )
      sections$.subscribe(data => this.state.set(SECTIONS_KEY, data)); // Save for client
      return sections$;
    }

    const cachedSections = this.state.get(SECTIONS_KEY, null);

    return cachedSections
      ? of(cachedSections) : this.requestService.post(
        `${EndpointConstant.section}/${EndpointConstant.filter}`,
        this.cityOrAddress
      );
  }

  getAllSections(): void {
    this.getAllSectionsObservable().subscribe((response: Array<SectionsInterface>) => {
      this.sections = response;
    })
  }

  openSectionPage(section: SectionsInterface, category: CategoryInterface): void {
    const sectionName = section.translatedName.toLowerCase();
    const categoryName = category.translatedName.toLowerCase();
    const cityName = this.cityService.getCityNameInEnglish();
    window.location.href = `${cityName}/${sectionName}/${categoryName}`;
  }
}
